/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Workspace role assigned to all invitees.
 */
export type CreateWorkspaceInvitationsRequestRole = typeof CreateWorkspaceInvitationsRequestRole[keyof typeof CreateWorkspaceInvitationsRequestRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWorkspaceInvitationsRequestRole = {
  OWNER: 'OWNER',
  APPROVER: 'APPROVER',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
} as const;
